export default function splitObject(obj: Record<string, any>, parts: string[]): any {
    // 使用Set提高查找效率，从 O(n) 降低到 O(1)
    const partsSet = new Set(parts);
    const left: Record<string, any> = {};
    const right: Record<string, any> = {};

    // 使用for...in替代Object.keys().forEach，减少函数调用开销
    for (const k in obj) {
        if (obj.hasOwnProperty(k)) {
            if (partsSet.has(k)) {
                left[k] = obj[k];
            } else {
                right[k] = obj[k];
            }
        }
    }

    return [left, right];
}
